<template>
  <DashboardWidget canGoFullscreen class="widget-analisi-reddituale" dialog-class="modal--type-dashboard-widget modal--type-dashboard-widget-analisi-reddituale" :title="title">
    <v-chart :options="chart" :autoresize="true" />
    <template #fullscreen>
      <v-chart :options="chart" :autoresize="true" />
    </template>
  </DashboardWidget>
</template>

<script>

import { monthNumberToLabel, monthsShort } from '../../../../../helpers/dates';
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/tooltip';

export default {
  components: {
    DashboardWidget: () => import('../DashboardWidget'),
    'v-chart': ECharts,
  },
  props: {
    title: {
      type: String,
    },
    values: {
      type: Array,
      default: () => null,
    },
  },
  computed: {
    valuesToUse () {
      if (this.values === null) {
        return [];
      }

      return this.values;
    },

    dataX () {
      return this.valuesToUse.map(v => monthNumberToLabel(v.month, monthsShort) + ' ' + v.year);
    },

    ricaviSeries () {
      return this.valuesToUse.map(v => v.ricavi);
    },
    personaleGASeries () {
      return this.valuesToUse.map(v => v.personaleGA);
    },
    cogsSeries () {
      return this.valuesToUse.map(v => v.cogs);
    },

    ebitdaSeries () {
      return this.valuesToUse.map(v => v.ebitda);
    },

    ricaviData () {
      return {
        name: 'Ricavi',
        type: 'bar',
        large: true,
        stack: 'only-stack',
        data: this.ricaviSeries,
        itemStyle: {
          color: '#EC632B',
        },
      };
    },
    personaleGAData () {
      return {
        name: 'Personale + G&A',
        type: 'bar',
        data: this.personaleGASeries,
        barGap: 0,
        stack: 'only-stack',
        itemStyle: {
          color: '#2d9cde',
        },
      };
    },
    cogsData () {
      return {
        name: 'COGS',
        type: 'bar',
        data: this.cogsSeries,
        barGap: 0,
        stack: 'only-stack',
        itemStyle: {
          color: 'rgba(45, 156, 222, .4)',
        },
      };
    },

    ebitdaData () {
      return {
        name: 'EBITDA',
        type: 'line',
        data: this.ebitdaSeries,
        itemStyle: {
          color: '#000000',
        },
        smooth: true,
      };
    },

    series () {
      return [
        this.ebitdaData,
        this.ricaviData,
        this.personaleGAData,
        this.cogsData,
      ];
    },
    legendData () {
      return this.series.map(s => s.name);
    },

    chart () {
      return {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          data: this.legendData,
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: this.dataX,
          },
        ],
        yAxis: [
          {
            type: 'value',
          },
        ],
        series: this.series,
      };
    },
  },
};

</script>

<style lang="scss">

.widget-analisi-reddituale {
  .echarts {
    width: 100%;
    height: 100%;
  }
}

.modal--type-dashboard-widget-analisi-reddituale {
  max-width: 80%;
  max-height: 80vh;

  .echarts {
    height: 80vh;
    width: 100%;
  }
}

</style>
